import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[user-dlg-func]',
    standalone: false
})
export class UserDlgFuncDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}